export const CONSTANTS = {
  SENTRY_DSN_FE:
    process.env.SENTRY_DSN_FE ??
    "https://1557db363034f1d27bdfda0f4fbf9a67@o4506744027676672.ingest.us.sentry.io/4506829217726464",
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  APIGEE_BASE_API_URL: "https://apigee.tdcx.com/flashhire",
  CANDIDATE_CLIENT_URL: "https://hire.tdcx.app/",
  RECRUITER_CLIENT_URL: "https://recruiters.tdcx.app/",
  LOGIN_PATH: "/login",
  LOGIN_REDIRECT_PATH: "/home",
  ACCESS_TOKEN_KEY_NAME: "hireAccessToken",
  REFRESH_TOKEN_KEY_NAME: "hireRefreshToken",
  PASSWORD_RESET_FORM_PATH: "/reset-password/:passwordResetToken",
  FORGOT_PASSWORD_PATH: "/reset-password",
  LOGIN_API_ENDPOINT: "/api/login",
  USER_INFO_API_ENDPOINT: "/api/me",
  REFRESH_TOKEN_ENDPOINT: "/api/refreshToken",
  CHANGEPASSWORD_API_ENDPOINT: "/api/change-password/",
  PASSWORD_TOKEN_VALIDITY_CHECK: `/api/reset-password/`,
  FORGOT_PASSWORD_ENDPOINT: "/api/reset-password/",
  FORGOT_CHANGE_PASSWORD_ENDPOINT: "/api/reset/change-password/",
  REGIONS_LIST_API: "/api/region-list/",
  EMAIL_TEMPLATE_TYPES_LIST: "/api/template-type/email/",
  MESSAGE_TEMPLATE_TYPES_LIST: "/api/template-type/message/",
  TEMPLATE_API: "/api/template/",
  COUNTRY_LIST_ENDPOINT: "/api/countries-list",
  CAMPAIGN_LIST_ENDPOINT: "/api/campaigns-list/",
  OVERALL_REGION_LIST_ENDPOINT: "/api/overall-regions",
  ADD_COUNTRY_ENDPOINT: "/api/country",
  UPDATE_COUNTRY_ENDPOINT: "api/country/",
  ADD_CAMPAIGN_ENDPOINT: "api/campaign",
  UPDATE_CAMPAIGN_ENDPOINT: "api/campaign/",
  TEMPLATE_TAGS_ENDPOINT: "api/template-tags",
  AUDIT_LOG_API_ENDPOINT: "api/audit-logs",
  DOWNLOAD_CSV_AUDIT_LOG_API_ENDPOINT: "download/audit-logs",
  USERS_LIST_API_ENDPOINT: "/api/users/",
  ROLES_LIST_API_ENDPOINT: "api/users-role/",
  COUNTRIES_LIST_API_ENDPOINT: "/api/users-countries",
  USER_REGISTER_ENDPOINT: "/api/users",
  USER_EDIT_DETAIL_ENDPOINT: "/api/users/edit/",
  USER_UPDATE_ENDPOINT: "/api/users/",
  USER_DELETE_ENDPOINT: "/api/users/",
  QUESTION_BANK_TEMPLATES_API: "api/question-bank-templates",
  QUESTION_BANK_ADD_TEMPLATES_API: "api/question-bank/template",
  QUESTION_BANK_UPDATE_TEMPLATES_API: "api/question-bank/template/",
  QUESTION_BANK_ADD_PRELIMINARY_API: "api/question-bank/preliminary",
  QUESTION_BANK_UPDATE_PRELIMINARY_API: "api/question-bank/preliminary/",
  QUESTION_BANK_ADD_COMPETENCIES_API: "api/question-bank/competencies/",
  QUESTION_BANK_UPDATE_COMPETENCIES_API: "api/question-bank/competencies/",
  QUESTION_BANK_ADD_QUESTION_COMPETENCIES_API:
    "api/question-bank-competencies/question",
  QUESTION_BANK_UPDATE_QUESTION_COMPETENCIES_API:
    "api/question-bank-competencies/question/",
  QUESTION_BANK_ADD_PRELIMINARY_QUESTION_API:
    "api/question-bank-preliminary/question",
  QUESTION_BANK_UPDATE_PRELIMINARY_QUESTION_API:
    "api/question-bank-preliminary/question/",
  QUESTION_BANK_ADD_ASSESSEMENT_API: "api/question-bank-template/assessment",
  QUESTION_BANK_UPDATE_ASSESSEMENT_API:
    "api/question-bank-template/assessment/",
  QUESTION_BANK_CK_EDITOR_FILE_UPLOAD_API:'api/question-bank/upload-file',
  TYPING_TEST_QUESTION_BANK_STATUS_UPDATE_API:'api/question-bank/update-typing-test-question=status',
  ADD_QUESTION_BANK_API: "/api/question-bank",
  QUESTION_BANK_DETAILS_API: "/api/question-bank",
  UPDATE_QUESTION_BANK_API: "/api/question-bank",
  REACT_APP_DISABLE_TWILIO_CONVERSATIONS: "true",
  QUESTION_BANK_CK_EDITOR_FILE_UPLOAD_API: "api/question-bank/upload-file",
  CHANGE_PASSWORD_PASSWORD_EXPIRED_QUERY_PARAM_FLAG: "passwordExpired",
  ENABLE_MAINTENANCE_BANNER: false,
};
